export default __webpack_public_path__ + "img/cash-multiple.7369ad49.svg";